export type Side = 'front' | 'back';
export const SIDES: Side[] = ['front', 'back'];
